<script setup>
import { computed } from 'vue'

const props = defineProps({
  flipped: {
    type: Boolean,
    default: false
  }
})

const flipClass = computed(() => ({
  'is-flipped': props.flipped
}))
</script>

<template>
  <div class="flip-container">
    <div class="flip-inner" :class="flipClass">
      <!-- Front Side -->
      <div class="flip-side flip-front">
        <slot name="front"></slot>
      </div>

      <!-- Back Side -->
      <div class="flip-side flip-back">
        <slot name="back"></slot>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Flip Container */
.flip-container {
  @apply w-full;
  perspective: 1000px;
}

/* Flip Inner - Both sides container */
.flip-inner {
  @apply relative w-full;
  transition: transform 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
  transform-style: preserve-3d;
}

/* Flipped state */
.flip-inner.is-flipped {
  transform: rotateY(180deg);
}

/* Common styles for both sides */
.flip-side {
  @apply w-full;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform-style: preserve-3d;
}

/* Front side - visible by default, hidden when flipped */
.flip-front {
  @apply relative;
  visibility: visible;
}

.is-flipped .flip-front {
  visibility: hidden;
}

/* Back side - hidden by default, visible when flipped */
.flip-back {
  @apply absolute top-0 left-0;
  transform: rotateY(180deg);
  visibility: hidden;
}

.is-flipped .flip-back {
  visibility: visible;
}

/* Smooth height transition */
.flip-container {
  transition: height 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
}

/* Mobile adjustments */
@media (max-width: 640px) {
  .flip-container {
    perspective: 800px;
  }

  .flip-inner {
    transition: transform 0.7s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
}
</style>
